import { BaseStore } from 'fluxible/addons';
import constants from 'contest/data/constants';

export default class ModalStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.modals = {
            [constants.AWARD_WINNER_MODAL]: {
                data: null,
            },
            [constants.SELECT_FINALISTS_MODAL]: {
                data: null,
            },
        };
        this.currentModal = null;
    }

    setCurrentModal(modal, data) {
        this.currentModal = modal;
        this.modals[modal].data = data;
    }

    clearCurrentModal(modal) {
        this.currentModal = null;
        this.modals[modal].data = null;
    }

    getModalData(modal) {
        return this.modals[modal].data;
    }

    isModalVisible(modal) {
        return this.currentModal === modal;
    }

    hideAllModals() {
        Object.keys(this.modals).map(modal => (this.modals[modal].data = null));
    }

    hideModal(modal) {
        if (!this.modals[modal]) {
            throw new Error(`No existing modal: ${modal}`);
        } else {
            this.clearCurrentModal(modal);
        }
        this.emitChange();
    }

    showModal({ modal, data }) {
        if (!this.modals[modal]) {
            throw new Error(`No existing modal: ${modal}`);
        } else {
            this.hideAllModals();
            this.setCurrentModal(modal, data);
        }
        this.emitChange();
    }
}
ModalStore.storeName = 'ModalStore';
ModalStore.handlers = {
    SHOW_MODAL: 'showModal',
    HIDE_MODAL: 'hideModal',
};



// WEBPACK FOOTER //
// ./src/web/js/contest/stores/modal-store.js